"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
var index_exports = {};
__export(index_exports, {
  AccidentalPreference: () => AccidentalPreference,
  DEFAULT_COLORS: () => DEFAULT_COLORS,
  FRETBOARD_MARGIN_FACTOR: () => FRETBOARD_MARGIN_FACTOR,
  ThemeMode: () => ThemeMode,
  createBaseGridLayer: () => createBaseGridLayer,
  createCurrentScaleNotesHook: () => createCurrentScaleNotesHook,
  createFeedbackStore: () => createFeedbackStore,
  createFretboardConfigStore: () => createFretboardConfigStore,
  createFretboardDimensionsHook: () => createFretboardDimensionsHook,
  createFretboardFrets: () => createFretboardFrets,
  createFretboardGradients: () => createFretboardGradients,
  createFretboardGrid: () => createFretboardGrid,
  createFretboardLayoutHook: () => createFretboardLayoutHook,
  createFretboardMarkers: () => createFretboardMarkers,
  createFretboardNoteQuizStore: () => createFretboardNoteQuizStore,
  createFretboardStrings: () => createFretboardStrings,
  createNoteFormatterHook: () => createNoteFormatterHook,
  createNoteGuessLayer: () => createNoteGuessLayer,
  createNoteQuizGradients: () => createNoteQuizGradients,
  createNotesLayer: () => createNotesLayer,
  createNotesLayerComponent: () => createNotesLayerComponent,
  createScaleDegreeColorHook: () => createScaleDegreeColorHook,
  createScaleDisplayLayer: () => createScaleDisplayLayer,
  createScaleDisplayStore: () => createScaleDisplayStore,
  createStandardizedScaleDegreeHook: () => createStandardizedScaleDegreeHook,
  createThemeStore: () => createThemeStore,
  darkThemeTokens: () => darkThemeTokens,
  formatFretRange: () => formatFretRange,
  formatNoteDisplay: () => formatNoteDisplay,
  formatPracticeRange: () => formatPracticeRange,
  formatStringRange: () => formatStringRange,
  getFretboardEdgeY: () => getFretboardEdgeY,
  getMarkerPosition: () => getMarkerPosition,
  lightThemeTokens: () => lightThemeTokens,
  useNoteQuizNotes: () => useNoteQuizNotes
});
module.exports = __toCommonJS(index_exports);

// src/fretboard/components/createBaseGridLayer.tsx
var import_react3 = __toESM(require("react"));

// src/fretboard/hooks/useFretboardLayout.ts
var import_react = require("react");

// src/fretboard/hooks/utils/layoutConstants.ts
var REFERENCE_HEIGHT = 200;
var FRETBOARD_MARGIN_FACTOR = 0.05;
var ELEMENT_SPACING_FACTOR = 0.9;
var HORIZONTAL_SPACING_FACTOR = 0.9;
var FONT_SIZE_FACTOR = 0.6;
var DEFAULT_MIN_TRAPEZOID_SCALE = 0.9;
var EXTRA_PADDING_BUFFER = 5;
var FRETBOARD_SCALING_MARGIN_FACTOR = 0.995;

// src/fretboard/hooks/utils/fretCalculations.ts
function calculateRegularFretMap(numFrets, fretWidthBase) {
  const baseMap = [0];
  let x = 0;
  const fretWidth = fretWidthBase;
  for (let i = 0; i < numFrets; i++) {
    x += fretWidth;
    baseMap.push(x);
  }
  return baseMap;
}
function calculate12TETFretMap(numFrets, fretWidthBase) {
  const lastFretIndex = numFrets - 1;
  const deltaLastFret = Math.pow(2, -(lastFretIndex / 12)) - Math.pow(2, -((lastFretIndex + 1) / 12));
  const S = fretWidthBase / deltaLastFret;
  const baseMap = [0];
  let x = 0;
  for (let i = 0; i < numFrets; i++) {
    const delta = Math.pow(2, -(i / 12)) - Math.pow(2, -((i + 1) / 12));
    const fretWidth = S * delta;
    x += fretWidth;
    baseMap.push(x);
  }
  return baseMap;
}
function addNutExtension(fretMap, nutExtension) {
  return fretMap.map((x) => x + nutExtension);
}
function scaleToFit(fretMap, numFrets, width) {
  const originalFullWidth = fretMap[numFrets];
  if (originalFullWidth < width) {
    const targetWidth = width * FRETBOARD_SCALING_MARGIN_FACTOR;
    const nutPosition = fretMap[0];
    const availableWidth = targetWidth - nutPosition;
    const originalWidth = originalFullWidth - nutPosition;
    const scaleFactor = availableWidth / originalWidth;
    return fretMap.map((pos, idx) => {
      if (idx === 0) return pos;
      return nutPosition + (pos - nutPosition) * scaleFactor;
    });
  }
  return fretMap;
}

// src/fretboard/hooks/utils/stringCalculations.ts
function calculateTrapezoidScaleAtX(x, width, isLeftHanded, useTrapezoidScaling, minTrapezoidScale) {
  if (!useTrapezoidScaling) {
    return 1;
  }
  const scaleRange = 1 - minTrapezoidScale;
  if (isLeftHanded) {
    return minTrapezoidScale + scaleRange * (width - x) / width;
  }
  return minTrapezoidScale + scaleRange * x / width;
}
function calculateStringY(stringIndex, _x, height, numStrings, trapezoidScale) {
  const margin = height * FRETBOARD_MARGIN_FACTOR;
  const availableHeight = height - 2 * margin;
  const scaledSpacing = availableHeight * trapezoidScale / (numStrings - 1);
  const totalScaledHeight = scaledSpacing * (numStrings - 1);
  const heightIncrease = totalScaledHeight - availableHeight;
  const centeringOffset = heightIncrease / 2;
  return margin + stringIndex * scaledSpacing - centeringOffset;
}

// src/fretboard/hooks/utils/positionCalculations.ts
function calculatePosition(stringIndex, fretNumber, getFretX, getStringY, isLeftHanded, fullWidth) {
  let centerX;
  if (fretNumber === 0) {
    const nutX = getFretX(0);
    if (isLeftHanded) {
      const openStringArea = fullWidth - nutX;
      centerX = nutX + openStringArea / 2;
    } else {
      centerX = nutX / 2;
    }
  } else {
    const xPrev = getFretX(fretNumber - 1);
    const xCurrent = getFretX(fretNumber);
    centerX = (xPrev + xCurrent) / 2;
  }
  const stringY = getStringY(stringIndex, centerX);
  return {
    centerX,
    centerY: stringY
  };
}

// src/fretboard/hooks/utils/elementCalculations.ts
function calculateVerticalElementConstraint(height, numStrings) {
  const margin = height * FRETBOARD_MARGIN_FACTOR;
  const availableHeight = height - 2 * margin;
  const stringSpacing = availableHeight / (numStrings - 1);
  return stringSpacing * ELEMENT_SPACING_FACTOR;
}
function calculateNutExtension(verticalElementConstraint, fretWidthBase) {
  const elementBasedExtension = verticalElementConstraint + verticalElementConstraint * 0.15;
  return Math.max(elementBasedExtension, fretWidthBase);
}
function calculateElementDimensions(getFretX, numFrets, verticalConstraint) {
  let minFretWidth = Infinity;
  for (let i = 1; i <= numFrets; i++) {
    const fretWidth = Math.abs(getFretX(i) - getFretX(i - 1));
    minFretWidth = Math.min(minFretWidth, fretWidth);
  }
  const horizontalConstraint = minFretWidth * HORIZONTAL_SPACING_FACTOR;
  const maxSize = Math.min(horizontalConstraint, verticalConstraint);
  return {
    width: maxSize,
    height: maxSize,
    fontSize: maxSize * FONT_SIZE_FACTOR
  };
}
function calculateVerticalPadding(elementWidth, getPosition, height, numFrets, numStrings) {
  const fretToCheck = numFrets;
  const elementRadius = elementWidth / 2;
  const topStringPosition = getPosition(0, fretToCheck);
  const bottomStringPosition = getPosition(numStrings - 1, fretToCheck);
  const topEdge = 0;
  const bottomEdge = height;
  const topOverflow = Math.max(0, elementRadius - (topStringPosition.centerY - topEdge));
  const bottomOverflow = Math.max(0, elementRadius - (bottomEdge - bottomStringPosition.centerY));
  return Math.max(topOverflow, bottomOverflow) + EXTRA_PADDING_BUFFER;
}

// src/fretboard/hooks/useFretboardLayout.ts
function createFretboardLayoutHook(useFretboardConfigStore) {
  return function useFretboardLayout(width, height) {
    const numFrets = useFretboardConfigStore((state) => state.numFrets);
    const isLeftHanded = useFretboardConfigStore((state) => state.isLeftHanded);
    const useEqualTemperament = useFretboardConfigStore((state) => state.useEqualTemperament);
    const useTrapezoidScaling = useFretboardConfigStore((state) => state.useTrapezoidScaling);
    const fretWidthBase = useFretboardConfigStore((state) => state.fretWidthBase);
    const model = useFretboardConfigStore((state) => state.fretboardModel);
    const numStrings = model.getDimensions().numStrings;
    const uiScale = (0, import_react.useMemo)(() => height / REFERENCE_HEIGHT, [height]);
    const verticalElementConstraint = (0, import_react.useMemo)(
      () => calculateVerticalElementConstraint(height, numStrings),
      [height, numStrings]
    );
    const nutExtension = (0, import_react.useMemo)(
      () => calculateNutExtension(verticalElementConstraint, fretWidthBase),
      [verticalElementConstraint, fretWidthBase]
    );
    const fretMap = (0, import_react.useMemo)(() => {
      let baseMap;
      if (!useEqualTemperament) {
        baseMap = calculateRegularFretMap(numFrets, fretWidthBase);
      } else {
        baseMap = calculate12TETFretMap(numFrets, fretWidthBase);
      }
      const mapWithExtension = addNutExtension(baseMap, nutExtension);
      return scaleToFit(mapWithExtension, numFrets, width);
    }, [numFrets, useEqualTemperament, width, nutExtension, fretWidthBase]);
    const fullWidth = (0, import_react.useMemo)(() => fretMap[numFrets], [fretMap, numFrets]);
    const minTrapezoidScale = useTrapezoidScaling ? DEFAULT_MIN_TRAPEZOID_SCALE : 1;
    const getTrapezoidScaleAtX = (0, import_react.useCallback)(
      (x) => calculateTrapezoidScaleAtX(x, width, isLeftHanded, useTrapezoidScaling, minTrapezoidScale),
      [width, isLeftHanded, useTrapezoidScaling, minTrapezoidScale]
    );
    const getStringY = (0, import_react.useCallback)(
      (stringIndex, x) => calculateStringY(stringIndex, x, height, numStrings, getTrapezoidScaleAtX(x)),
      [height, numStrings, getTrapezoidScaleAtX]
    );
    const getFretX = (0, import_react.useCallback)(
      (fretNumber) => {
        const standardX = fretMap[Math.min(fretNumber, numFrets)];
        if (isLeftHanded) {
          return fullWidth - standardX;
        }
        return standardX;
      },
      [fretMap, numFrets, fullWidth, isLeftHanded]
    );
    const getPosition = (0, import_react.useCallback)(
      (stringIndex, fretNumber) => calculatePosition(stringIndex, fretNumber, getFretX, getStringY, isLeftHanded, fullWidth),
      [getFretX, getStringY, isLeftHanded, fullWidth]
    );
    const elementDimensions = (0, import_react.useMemo)(
      () => calculateElementDimensions(getFretX, numFrets, verticalElementConstraint),
      [getFretX, numFrets, verticalElementConstraint]
    );
    const verticalPadding = (0, import_react.useMemo)(
      () => calculateVerticalPadding(
        elementDimensions.width,
        getPosition,
        height,
        numFrets,
        numStrings
      ),
      [elementDimensions.width, getPosition, height, numFrets, numStrings]
    );
    return {
      width,
      height,
      numStrings,
      numFrets,
      uiScale,
      fullWidth,
      nutExtension,
      verticalPadding,
      elementDimensions,
      getPosition,
      getFretX,
      getStringY
    };
  };
}

// src/fretboard/hooks/useFretboardDimensions.ts
var import_react2 = require("react");
function createFretboardDimensionsHook(measurementConfig, useFretboardConfigStoreHook) {
  return function useFretboardDimensions(containerRef) {
    const [dimensions, setDimensions] = (0, import_react2.useState)({
      width: 0,
      height: 0
    });
    const previousValues = (0, import_react2.useRef)({
      containerWidth: 0,
      availableHeight: 0,
      heightRatio: 0
    });
    const heightRatio = useFretboardConfigStoreHook((state) => state.heightRatio);
    const updateDimensions = (0, import_react2.useCallback)(
      (newDimensions) => {
        if (newDimensions.width !== dimensions.width || newDimensions.height !== dimensions.height) {
          setDimensions(newDimensions);
        }
      },
      [dimensions.width, dimensions.height]
    );
    const calculateDimensions = (0, import_react2.useCallback)(() => {
      const containerWidth = measurementConfig.getContainerWidth(containerRef);
      const availableHeight = measurementConfig.getAvailableHeight(containerRef);
      if (!containerWidth) {
        return;
      }
      const prev = previousValues.current;
      const valuesChanged = containerWidth !== prev.containerWidth || availableHeight !== prev.availableHeight || heightRatio !== prev.heightRatio;
      if (!valuesChanged) {
        return;
      }
      previousValues.current = {
        containerWidth,
        availableHeight,
        heightRatio
      };
      const calculatedHeight = availableHeight * heightRatio;
      updateDimensions({
        width: containerWidth,
        height: calculatedHeight
      });
    }, [containerRef, heightRatio, measurementConfig, updateDimensions]);
    (0, import_react2.useEffect)(() => {
      calculateDimensions();
      const cleanupResizeHandler = measurementConfig.setupResizeHandling(calculateDimensions);
      return cleanupResizeHandler;
    }, [calculateDimensions, measurementConfig]);
    (0, import_react2.useEffect)(() => {
      calculateDimensions();
    }, [heightRatio, calculateDimensions]);
    return dimensions;
  };
}

// src/fretboard/utils.ts
function getFretboardEdgeY(layout, isTop, x) {
  const padding = layout.height * FRETBOARD_MARGIN_FACTOR;
  const stringY = isTop ? layout.getStringY(0, x) : layout.getStringY(layout.numStrings - 1, x);
  return isTop ? stringY - padding : stringY + padding;
}
function getMarkerPosition(layout, fret) {
  const thisFretX = layout.getFretX(fret);
  const prevFretX = layout.getFretX(fret - 1);
  const markerX = (thisFretX + prevFretX) / 2;
  return {
    cx: markerX,
    cy: layout.height / 2
  };
}

// src/fretboard/components/createBaseGridLayer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
function createBaseGridLayer({
  G,
  FretboardGradients,
  FretboardGrid,
  FretboardFrets,
  FretboardStrings,
  FretboardMarkers
}) {
  return function BaseGridLayer({ layout }) {
    const fretPositions = import_react3.default.useMemo(() => {
      return Array.from({ length: layout.numFrets + 1 }, (_, i) => layout.getFretX(i));
    }, [layout]);
    const getFretboardEdgeYBound = import_react3.default.useCallback(
      (isTop, x) => getFretboardEdgeY(layout, isTop, x),
      [layout]
    );
    const getMarkerPositionBound = import_react3.default.useCallback(
      (fret) => getMarkerPosition(layout, fret),
      [layout]
    );
    const idPrefix = import_react3.default.useId();
    const gradientIds = {
      woodGrain: `woodGrain-${idPrefix}`,
      woodPattern: `woodPattern-${idPrefix}`,
      fretMetal: `fretMetal-${idPrefix}`,
      pearlInlay: `pearlInlay-${idPrefix}`,
      abalone: `abalone-${idPrefix}`,
      stringGleam: `stringGleam-${idPrefix}`
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(G, { className: "fretboard-grid", children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FretboardGradients, { gradientIds }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FretboardGrid, { layout, gradientIds }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        FretboardFrets,
        {
          layout,
          fretPositions,
          getFretboardEdgeY: getFretboardEdgeYBound
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FretboardStrings, { layout }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        FretboardMarkers,
        {
          layout,
          getMarkerPosition: getMarkerPositionBound,
          gradientIds
        }
      )
    ] });
  };
}

// src/fretboard/components/createFretboardFrets.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
function createFretboardFrets({ G, Line, useThemeStore }) {
  return function FretboardFrets({
    layout,
    fretPositions,
    getFretboardEdgeY: getFretboardEdgeY2
  }) {
    const colors = useThemeStore((state) => state.colors);
    return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_jsx_runtime2.Fragment, { children: fretPositions.map((x, i) => {
      const topY = getFretboardEdgeY2(true, x);
      const bottomY = getFretboardEdgeY2(false, x);
      const isNut = i === 0;
      const fretWidth = (isNut ? 5 : 3) * layout.uiScale;
      const fretColor = isNut ? colors.nutColor : colors.fretColor;
      return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(G, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          Line,
          {
            x1: x,
            y1: topY,
            x2: x,
            y2: bottomY,
            stroke: "rgba(0,0,0,0.45)",
            strokeWidth: fretWidth + 1,
            transform: "translate(1.5, 1.5)"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          Line,
          {
            x1: x,
            y1: topY,
            x2: x,
            y2: bottomY,
            stroke: "rgba(0,0,0,0.3)",
            strokeWidth: fretWidth,
            transform: "translate(1, 1)"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          Line,
          {
            x1: x,
            y1: topY,
            x2: x,
            y2: bottomY,
            stroke: fretColor,
            strokeWidth: fretWidth,
            style: {
              filter: isNut ? "drop-shadow(-1px 0 1px rgba(0,0,0,0.5))" : "drop-shadow(0px 0px 1px rgba(0,0,0,0.3))"
            }
          }
        )
      ] }, `fret-${i}`);
    }) });
  };
}

// src/fretboard/components/createFretboardGradients.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
function createFretboardGradients({
  Defs,
  LinearGradient,
  RadialGradient,
  Stop,
  Pattern,
  Rect,
  G,
  Line,
  useThemeStore
}) {
  return function FretboardGradients({ gradientIds }) {
    const colors = useThemeStore((state) => state.colors);
    return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(Defs, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(LinearGradient, { id: gradientIds.woodGrain, x1: "0%", y1: "0%", x2: "100%", y2: "0%", children: [
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "0%", style: { stopColor: colors.fretboardWood, stopOpacity: 1 } }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "100%", style: { stopColor: colors.fretboardWood, stopOpacity: 1 } })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
        Pattern,
        {
          id: gradientIds.woodPattern,
          patternUnits: "userSpaceOnUse",
          width: "100%",
          height: "30",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Rect, { width: "100%", height: "30", fill: `url(#${gradientIds.woodGrain})` }),
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(G, { opacity: "0.03", children: Array.from({ length: 3 }).map((_, i) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
              Line,
              {
                x1: "0",
                y1: i * 10 + 5,
                x2: "100%",
                y2: i * 10 + 5,
                stroke: "#2a1a0c",
                strokeWidth: "0.5"
              },
              `grain-line-${i}`
            )) })
          ]
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(LinearGradient, { id: gradientIds.fretMetal, x1: "0%", y1: "0%", x2: "0%", y2: "100%", children: [
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "0%", style: { stopColor: colors.fretMetalLight, stopOpacity: 1 } }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "30%", style: { stopColor: colors.fretMetalMid, stopOpacity: 1 } }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "50%", style: { stopColor: colors.fretMetalDark, stopOpacity: 1 } }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "70%", style: { stopColor: colors.fretMetalMid, stopOpacity: 1 } }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "100%", style: { stopColor: colors.fretMetalLight, stopOpacity: 1 } })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
        RadialGradient,
        {
          id: gradientIds.pearlInlay,
          gradientUnits: "objectBoundingBox",
          cx: "0.5",
          cy: "0.5",
          r: "0.5",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "0%", style: { stopColor: colors.pearlInlay[0], stopOpacity: 0.95 } }),
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "50%", style: { stopColor: colors.pearlInlay[1], stopOpacity: 0.9 } }),
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "70%", style: { stopColor: colors.pearlInlay[2], stopOpacity: 0.85 } }),
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "85%", style: { stopColor: colors.pearlInlay[3], stopOpacity: 0.8 } }),
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "100%", style: { stopColor: colors.pearlInlay[4], stopOpacity: 0.75 } })
          ]
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
        RadialGradient,
        {
          id: gradientIds.abalone,
          gradientUnits: "objectBoundingBox",
          cx: "0.5",
          cy: "0.5",
          r: "0.7",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "0%", style: { stopColor: colors.abalone[0], stopOpacity: 0.95 } }),
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "20%", style: { stopColor: colors.abalone[1], stopOpacity: 0.9 } }),
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "40%", style: { stopColor: colors.abalone[2], stopOpacity: 0.85 } }),
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "60%", style: { stopColor: colors.abalone[3], stopOpacity: 0.8 } }),
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "80%", style: { stopColor: colors.abalone[4], stopOpacity: 0.75 } }),
            /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "100%", style: { stopColor: colors.abalone[5], stopOpacity: 0.7 } })
          ]
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(LinearGradient, { id: gradientIds.stringGleam, x1: "0%", y1: "0%", x2: "100%", y2: "0%", children: [
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "0%", style: { stopColor: "rgba(255,255,255,0)", stopOpacity: 0 } }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "45%", style: { stopColor: "rgba(255,255,255,0)", stopOpacity: 0 } }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "50%", style: { stopColor: "rgba(255,255,255,0.9)", stopOpacity: 0.9 } }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "55%", style: { stopColor: "rgba(255,255,255,0)", stopOpacity: 0 } }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Stop, { offset: "100%", style: { stopColor: "rgba(255,255,255,0)", stopOpacity: 0 } })
      ] })
    ] });
  };
}

// src/fretboard/components/createFretboardGrid.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
function createFretboardGrid({ Path }) {
  return function FretboardGrid({ layout, gradientIds = {} }) {
    const totalWidth = layout.fullWidth;
    const nutExtension = layout.nutExtension;
    const woodPatternId = gradientIds.woodPattern || "woodPattern";
    return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_jsx_runtime4.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
      Path,
      {
        d: `
            M ${-nutExtension},${getFretboardEdgeY(layout, true, 0)}
            L ${totalWidth},${getFretboardEdgeY(layout, true, totalWidth)}
            L ${totalWidth},${getFretboardEdgeY(layout, false, totalWidth)}
            L ${-nutExtension},${getFretboardEdgeY(layout, false, 0)}
            Z
          `,
        fill: `url(#${woodPatternId})`,
        className: "shadow-inner",
        style: { filter: "drop-shadow(0px 2px 3px rgba(0,0,0,0.3))" }
      }
    ) });
  };
}

// src/fretboard/components/createFretboardMarkers.tsx
var import_core = require("@fretgenius/core");
var import_jsx_runtime5 = require("react/jsx-runtime");
function createFretboardMarkers({ G, Circle }) {
  return function FretboardMarkers({
    layout,
    getMarkerPosition: getMarkerPosition2,
    gradientIds
  }) {
    return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_jsx_runtime5.Fragment, { children: import_core.FRET_MARKER_POSITIONS.filter((fret) => fret <= layout.numFrets).map((fret) => {
      const { cx } = getMarkerPosition2(fret);
      const markerRadius = 5 * layout.uiScale;
      const isSpecialMarker = fret % 12 === 0;
      const markerFill = isSpecialMarker ? `url(#${gradientIds.abalone})` : `url(#${gradientIds.pearlInlay})`;
      if (isSpecialMarker) {
        return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(G, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            Circle,
            {
              cx: cx + 1,
              cy: layout.height / 2 - 34 * layout.uiScale,
              r: markerRadius,
              fill: "rgba(0,0,0,0.3)"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            Circle,
            {
              cx: cx + 1,
              cy: layout.height / 2 + 36 * layout.uiScale,
              r: markerRadius,
              fill: "rgba(0,0,0,0.3)"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            Circle,
            {
              cx,
              cy: layout.height / 2 - 35 * layout.uiScale,
              r: markerRadius,
              fill: markerFill,
              className: "marker",
              style: {
                filter: "drop-shadow(-1px 1px 2px rgba(0,0,0,0.4))"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            Circle,
            {
              cx,
              cy: layout.height / 2 + 35 * layout.uiScale,
              r: markerRadius,
              fill: markerFill,
              className: "marker",
              style: {
                filter: "drop-shadow(-1px 1px 2px rgba(0,0,0,0.4))"
              }
            }
          )
        ] }, `marker-double-${fret}`);
      }
      return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(G, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
          Circle,
          {
            cx: cx + 1,
            cy: layout.height / 2 + 1,
            r: markerRadius,
            fill: "rgba(0,0,0,0.3)"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
          Circle,
          {
            cx,
            cy: layout.height / 2,
            r: markerRadius,
            fill: markerFill,
            className: "marker",
            style: {
              filter: "drop-shadow(-1px 1px 2px rgba(0,0,0,0.4))"
            }
          }
        )
      ] }, `marker-${fret}`);
    }) });
  };
}

// src/fretboard/components/createFretboardStrings.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
function createFretboardStrings({ G, Line, useThemeStore }) {
  return function FretboardStrings({ layout }) {
    const colors = useThemeStore((state) => state.colors);
    const totalWidth = layout.fullWidth;
    const nutExtension = layout.nutExtension;
    return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_jsx_runtime6.Fragment, { children: Array.from({ length: layout.numStrings }).map((_, i) => {
      const stringThickness = Math.max(1.2, 1.2 + i * 0.6) * layout.uiScale;
      const startY = layout.getStringY(i, 0);
      const endY = layout.getStringY(i, totalWidth);
      const baseColor = i < layout.numStrings / 2 ? colors.stringColorTreble : colors.stringColorBass;
      return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(G, { children: [
        /* Base string */
        /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
          Line,
          {
            x1: -nutExtension,
            y1: startY,
            x2: totalWidth,
            y2: endY,
            strokeLinecap: "round",
            className: "string",
            style: {
              stroke: baseColor,
              strokeWidth: stringThickness,
              filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.4))"
            }
          },
          `string-line-${i}`
        )
      ] }, `string-${i}`);
    }) });
  };
}

// src/fretboard/components/createNotesLayerComponent.tsx
var import_react4 = __toESM(require("react"));
var import_jsx_runtime7 = require("react/jsx-runtime");
function createNotesLayerComponent(deps) {
  const {
    G,
    Circle,
    Rect,
    Defs,
    RadialGradient,
    Stop,
    Text,
    useThemeStore,
    useFretboardConfigStore,
    platform
  } = deps;
  return function NotesLayer({
    layout,
    notes,
    noteCircleScale: propNoteCircleScale,
    onNoteClick,
    baseGradientId,
    textColor,
    renderAdditionalContent
  }) {
    const storeNoteCircleScale = useFretboardConfigStore((state) => state.noteCircleScale);
    const noteCircleScale = propNoteCircleScale != null ? propNoteCircleScale : storeNoteCircleScale;
    const colors = useThemeStore((state) => state.colors);
    const finalTextColor = textColor || colors.textPrimary;
    const defaultGradientId = import_react4.default.useId();
    const gradientId = baseGradientId || `note-circle-gradient-${defaultGradientId}`;
    const createPressHandler = (0, import_react4.useCallback)(
      (note) => {
        if (!onNoteClick) return void 0;
        return (event) => onNoteClick(note, event);
      },
      [onNoteClick]
    );
    const renderNote = (0, import_react4.useCallback)(
      (note, index) => {
        if (!note.visible) return null;
        const position = layout.getPosition(note.string, note.fret);
        const dimensions = layout.elementDimensions;
        const circleRadius = dimensions.width / 2 * noteCircleScale;
        const fillColor = note.color || `url(#${gradientId})`;
        const key = `note-${note.string}-${note.fret}-${index}`;
        const handlePress = createPressHandler(note);
        const textY = platform === "web" ? position.centerY : position.centerY + dimensions.fontSize * 0.35;
        const children = [];
        children.push(
          /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
            Circle,
            {
              cx: position.centerX,
              cy: position.centerY,
              r: circleRadius,
              fill: fillColor,
              stroke: "transparent",
              style: platform === "web" ? {
                transition: "all 0.2s ease-in-out",
                filter: "drop-shadow(0px 2px 4px rgba(0,0,0,0.4))"
              } : void 0
            },
            "circle"
          )
        );
        if (note.content && typeof note.content === "string") {
          children.push(
            /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
              Text,
              {
                x: position.centerX,
                y: textY,
                textAnchor: "middle",
                dominantBaseline: "central",
                fill: finalTextColor,
                fontSize: dimensions.fontSize * noteCircleScale,
                fontWeight: "bold",
                letterSpacing: "0",
                children: note.content
              },
              "text"
            )
          );
        }
        if (renderAdditionalContent) {
          const additionalContent = renderAdditionalContent(note, position);
          if (additionalContent && import_react4.default.isValidElement(additionalContent)) {
            children.push(additionalContent);
          }
        }
        const eventProps = {};
        if (platform === "web") {
          eventProps.onClick = handlePress;
        } else if (platform === "react-native-web") {
          eventProps.onPress = handlePress;
        } else if (platform === "mobile") {
          eventProps.onPressOut = handlePress;
        }
        children.push(
          /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
            Rect,
            __spreadValues({
              x: position.centerX - circleRadius,
              y: position.centerY - circleRadius,
              width: circleRadius * 2,
              height: circleRadius * 2,
              fill: "transparent"
            }, eventProps),
            "touch-target"
          )
        );
        return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
          G,
          {
            style: {
              cursor: onNoteClick ? "pointer" : "default",
              transition: "all 0.2s ease-in-out"
            },
            children
          },
          key
        );
      },
      [
        layout,
        noteCircleScale,
        gradientId,
        colors.background,
        finalTextColor,
        renderAdditionalContent,
        createPressHandler,
        platform
      ]
    );
    const renderedNotes = (0, import_react4.useMemo)(() => {
      const validNotes = notes.map((note, index) => renderNote(note, index)).filter((node) => node !== null);
      return validNotes;
    }, [notes, renderNote]);
    const gradientDefs = (0, import_react4.useMemo)(() => {
      if (baseGradientId) return null;
      return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(Defs, { children: /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)(
        RadialGradient,
        {
          id: gradientId,
          gradientUnits: "objectBoundingBox",
          cx: "0.5",
          cy: "0.4",
          r: "0.6",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
              Stop,
              {
                offset: "0",
                style: {
                  stopColor: colors.background,
                  stopOpacity: 0.98
                }
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
              Stop,
              {
                offset: "0.7",
                style: {
                  stopColor: colors.surfacePrimary,
                  stopOpacity: 0.95
                }
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
              Stop,
              {
                offset: "1",
                style: {
                  stopColor: colors.surfaceSecondary,
                  stopOpacity: 0.9
                }
              }
            )
          ]
        }
      ) });
    }, [baseGradientId, gradientId, colors, platform]);
    const elements = [];
    if (gradientDefs) {
      elements.push(import_react4.default.cloneElement(gradientDefs, { key: "gradient-defs" }));
    }
    if (renderedNotes.length > 0) {
      elements.push(/* @__PURE__ */ (0, import_jsx_runtime7.jsx)(G, { children: renderedNotes }, "notes-group"));
    }
    return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(import_jsx_runtime7.Fragment, { children: elements });
  };
}

// src/fretboard/components/createNotesLayer.tsx
function createNotesLayer(deps) {
  return createNotesLayerComponent(deps);
}

// src/fretboard/stores/format.ts
var import_core2 = require("@fretgenius/core");

// src/fretboard/types/AccidentalPreference.ts
var AccidentalPreference = /* @__PURE__ */ ((AccidentalPreference2) => {
  AccidentalPreference2["Sharp"] = "sharp";
  AccidentalPreference2["Flat"] = "flat";
  return AccidentalPreference2;
})(AccidentalPreference || {});

// src/fretboard/stores/format.ts
function formatNoteDisplay(note, accidentalPreference) {
  if (accidentalPreference === "flat" /* Flat */) {
    return import_core2.ENHARMONIC_SHARP_TO_FLAT[note] || note;
  } else if (accidentalPreference === "sharp" /* Sharp */) {
    return import_core2.ENHARMONIC_FLAT_TO_SHARP[note] || note;
  }
  return note;
}

// src/fretboard/stores/useFretboardConfigStore.ts
var import_core3 = require("@fretgenius/core");
var import_zustand = require("zustand");
var import_middleware = require("zustand/middleware");
var createFretboardConfigStore = (options, initialConfig) => {
  const { storage, reportErrorFn } = options;
  return (0, import_zustand.create)()(
    (0, import_middleware.persist)(
      (set, get) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        const baseInstrumentType = (_a = initialConfig == null ? void 0 : initialConfig.instrumentType) != null ? _a : import_core3.InstrumentType.Guitar;
        const initialInstrumentType = baseInstrumentType;
        const initialTuningId = (_b = initialConfig == null ? void 0 : initialConfig.tuningId) != null ? _b : import_core3.INSTRUMENTS_BY_TYPE[initialInstrumentType].defaultTunings[0].id;
        const initialNumFrets = (_c = initialConfig == null ? void 0 : initialConfig.numFrets) != null ? _c : import_core3.INSTRUMENTS_BY_TYPE[initialInstrumentType].defaultNumFrets;
        const initialHeightRatio = (_d = initialConfig == null ? void 0 : initialConfig.heightRatio) != null ? _d : 0.4;
        const initialUseEqualTemperament = (_e = initialConfig == null ? void 0 : initialConfig.useEqualTemperament) != null ? _e : false;
        const initialUseTrapezoidScaling = (_f = initialConfig == null ? void 0 : initialConfig.useTrapezoidScaling) != null ? _f : true;
        const initialNoteCircleScale = (_g = initialConfig == null ? void 0 : initialConfig.noteCircleScale) != null ? _g : 0.8;
        const initialIsLeftHanded = (_h = initialConfig == null ? void 0 : initialConfig.isLeftHanded) != null ? _h : false;
        const initialAccidentalPreference = (_i = initialConfig == null ? void 0 : initialConfig.accidentalPreference) != null ? _i : "sharp" /* Sharp */;
        const initialFretWidthBase = (_j = initialConfig == null ? void 0 : initialConfig.fretWidthBase) != null ? _j : 35;
        const initialShowFretMarkerLabels = (_k = initialConfig == null ? void 0 : initialConfig.showFretMarkerLabels) != null ? _k : true;
        const initialFretboardModel = new import_core3.FretboardModel({
          instrumentType: initialInstrumentType,
          tuningId: initialTuningId,
          numFrets: initialNumFrets
        });
        return {
          instrumentType: initialInstrumentType,
          tuningId: initialTuningId,
          numFrets: initialNumFrets,
          heightRatio: initialHeightRatio,
          fretboardModel: initialFretboardModel,
          useEqualTemperament: initialUseEqualTemperament,
          useTrapezoidScaling: initialUseTrapezoidScaling,
          noteCircleScale: initialNoteCircleScale,
          isLeftHanded: initialIsLeftHanded,
          accidentalPreference: initialAccidentalPreference,
          fretWidthBase: initialFretWidthBase,
          showFretMarkerLabels: initialShowFretMarkerLabels,
          setAccidentalPreference: (preference) => set({ accidentalPreference: preference }),
          setUseTrapezoidScaling: (useTrapezoidScaling) => set({ useTrapezoidScaling }),
          setFretWidthBase: (width) => {
            const validWidth = Math.max(20, Math.min(100, width));
            set({ fretWidthBase: validWidth });
          },
          setInstrumentType: (instrumentType) => {
            const defaultTuningIdForInstrument = import_core3.INSTRUMENTS_BY_TYPE[instrumentType].defaultTunings[0].id;
            set({
              instrumentType,
              tuningId: defaultTuningIdForInstrument
            });
            set({
              fretboardModel: new import_core3.FretboardModel({
                instrumentType,
                tuningId: defaultTuningIdForInstrument,
                numFrets: get().numFrets
              })
            });
          },
          setTuningId: (tuningId) => {
            set({ tuningId });
            set({
              fretboardModel: new import_core3.FretboardModel({
                instrumentType: get().instrumentType,
                tuningId,
                numFrets: get().numFrets
              })
            });
          },
          setNumFrets: (numFrets) => {
            set({ numFrets });
            set({
              fretboardModel: new import_core3.FretboardModel({
                instrumentType: get().instrumentType,
                tuningId: get().tuningId,
                numFrets
              })
            });
          },
          setHeightRatio: (heightRatio) => {
            const validHeightRatio = Math.max(0.15, Math.min(1, heightRatio));
            set({ heightRatio: validHeightRatio });
          },
          setUseEqualTemperament: (useEqualTemperament) => set({ useEqualTemperament }),
          setNoteCircleScale: (scale) => {
            const validScale = Math.max(0.4, Math.min(1, scale));
            set({ noteCircleScale: validScale });
          },
          setIsLeftHanded: (isLeftHanded) => set({ isLeftHanded }),
          setShowFretMarkerLabels: (show) => set({ showFretMarkerLabels: show })
        };
      },
      {
        name: "fretboard-preferences",
        // name of the item in storage
        storage,
        partialize: (state) => ({
          // Only persist these user preference values (exclude complex objects like fretboardModel)
          instrumentType: state.instrumentType,
          tuningId: state.tuningId,
          numFrets: state.numFrets,
          heightRatio: state.heightRatio,
          useEqualTemperament: state.useEqualTemperament,
          useTrapezoidScaling: state.useTrapezoidScaling,
          noteCircleScale: state.noteCircleScale,
          isLeftHanded: state.isLeftHanded,
          accidentalPreference: state.accidentalPreference,
          fretWidthBase: state.fretWidthBase,
          showFretMarkerLabels: state.showFretMarkerLabels
        }),
        // Re-create FretboardModel from persisted values
        onRehydrateStorage: () => {
          return (persistedState, error) => {
            if (error) {
              reportErrorFn(error, {
                source: "createFretboardConfigStore.onRehydrateStorage"
              });
              return;
            }
            if (persistedState) {
              persistedState.fretboardModel = new import_core3.FretboardModel({
                instrumentType: persistedState.instrumentType,
                tuningId: persistedState.tuningId,
                numFrets: persistedState.numFrets
              });
            }
          };
        }
      }
    )
  );
};

// src/note-quiz/useNoteQuizNotes.ts
var import_react5 = require("react");
var useNoteQuizNotes = ({
  layout,
  model,
  rangeConfig,
  revealedAnswers,
  isAnswered,
  equivalentPositions,
  accidentalPreference,
  circleGradientId,
  correctGradientId,
  incorrectGradientId,
  inactiveGradientId,
  equivalentGradientId
}) => {
  return (0, import_react5.useMemo)(() => {
    const allNotes = [];
    for (let stringIndex = 0; stringIndex < layout.numStrings; stringIndex++) {
      if (!rangeConfig.activeStrings.includes(stringIndex)) {
        continue;
      }
      for (let fretNumber = 0; fretNumber <= layout.numFrets; fretNumber++) {
        if (fretNumber < rangeConfig.fretRange.min || fretNumber > rangeConfig.fretRange.max) {
          continue;
        }
        const positionData = model.getPosition(stringIndex, fretNumber);
        if (!positionData) {
          console.warn(
            `Could not find position data for string ${stringIndex}, fret ${fretNumber}`
          );
          continue;
        }
        const fretPosition = {
          string: stringIndex,
          fret: fretNumber,
          pitch: positionData.pitch
        };
        const revealedAnswer = revealedAnswers.find(
          (answer) => answer.position.string === stringIndex && answer.position.fret === fretNumber
        );
        const isEquivalentPosition = isAnswered && equivalentPositions.some(
          (equiv) => equiv.string === stringIndex && equiv.fret === fretNumber
        );
        let color;
        let content;
        let className = "";
        if (revealedAnswer) {
          color = revealedAnswer.isCorrect ? `url(#note-circle-correct-${correctGradientId})` : `url(#note-circle-incorrect-${incorrectGradientId})`;
          content = formatNoteDisplay(fretPosition.pitch.note, accidentalPreference);
          className = revealedAnswer.isCorrect ? "correct" : "incorrect";
        } else if (isEquivalentPosition) {
          color = `url(#note-circle-equivalent-${equivalentGradientId})`;
          content = formatNoteDisplay(fretPosition.pitch.note, accidentalPreference);
          className = "equivalent";
        } else if (isAnswered) {
          color = `url(#note-circle-inactive-${inactiveGradientId})`;
          className = "inactive";
        } else {
          color = `url(#note-circle-gradient-${circleGradientId})`;
          className = "active";
        }
        allNotes.push({
          string: stringIndex,
          fret: fretNumber,
          color,
          content,
          visible: true,
          className,
          metadata: fretPosition
        });
      }
    }
    return allNotes;
  }, [
    layout,
    model,
    rangeConfig,
    revealedAnswers,
    isAnswered,
    equivalentPositions,
    accidentalPreference,
    circleGradientId,
    correctGradientId,
    incorrectGradientId,
    inactiveGradientId,
    equivalentGradientId
  ]);
};

// src/note-quiz/createNoteQuizGradients.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
function createNoteQuizGradients({
  Defs,
  RadialGradient,
  Stop,
  platform
}) {
  return function NoteQuizGradients({
    circleGradientId,
    correctGradientId,
    incorrectGradientId,
    inactiveGradientId,
    equivalentGradientId
  }) {
    const offsetFormat = (value) => platform.OS === "web" ? `${value}%` : `${value / 100}`;
    return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(Defs, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
        RadialGradient,
        {
          id: `note-circle-gradient-${circleGradientId}`,
          gradientUnits: "objectBoundingBox",
          cx: "0.5",
          cy: "0.4",
          r: "0.6",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(0), style: { stopColor: "#ffffff", stopOpacity: 0.98 } }),
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(70), style: { stopColor: "#f8f8f8", stopOpacity: 0.95 } }),
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(100), style: { stopColor: "#f0f0f0", stopOpacity: 0.9 } })
          ]
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
        RadialGradient,
        {
          id: `note-circle-correct-${correctGradientId}`,
          gradientUnits: "objectBoundingBox",
          cx: "0.5",
          cy: "0.4",
          r: "0.6",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(0), style: { stopColor: "#c8f5d0", stopOpacity: 0.98 } }),
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(70), style: { stopColor: "#75e088", stopOpacity: 0.95 } }),
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(100), style: { stopColor: "#5cc76d", stopOpacity: 0.9 } })
          ]
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
        RadialGradient,
        {
          id: `note-circle-incorrect-${incorrectGradientId}`,
          gradientUnits: "objectBoundingBox",
          cx: "0.5",
          cy: "0.4",
          r: "0.6",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(0), style: { stopColor: "#f5c8c8", stopOpacity: 0.98 } }),
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(70), style: { stopColor: "#e07575", stopOpacity: 0.95 } }),
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(100), style: { stopColor: "#c75c5c", stopOpacity: 0.9 } })
          ]
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
        RadialGradient,
        {
          id: `note-circle-inactive-${inactiveGradientId}`,
          gradientUnits: "objectBoundingBox",
          cx: "0.5",
          cy: "0.4",
          r: "0.6",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(0), style: { stopColor: "#f0f0f0", stopOpacity: 0.7 } }),
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(70), style: { stopColor: "#e0e0e0", stopOpacity: 0.6 } }),
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(100), style: { stopColor: "#d0d0d0", stopOpacity: 0.5 } })
          ]
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
        RadialGradient,
        {
          id: `note-circle-equivalent-${equivalentGradientId}`,
          gradientUnits: "objectBoundingBox",
          cx: "0.5",
          cy: "0.4",
          r: "0.6",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(0), style: { stopColor: "#c8e5f5", stopOpacity: 0.98 } }),
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(70), style: { stopColor: "#75c0e0", stopOpacity: 0.95 } }),
            /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Stop, { offset: offsetFormat(100), style: { stopColor: "#5ca7c7", stopOpacity: 0.9 } })
          ]
        }
      )
    ] });
  };
}

// src/note-quiz/createNoteGuessLayer.tsx
var import_react6 = __toESM(require("react"));
var import_jsx_runtime9 = require("react/jsx-runtime");
function createNoteGuessLayer(deps) {
  const {
    G,
    NoteQuizGradients,
    NotesLayer,
    useFretboardConfigStore,
    useFretboardNoteQuizStore,
    useNoteQuizNotes: useNoteQuizNotes2
  } = deps;
  return function NoteGuessLayer({
    layout,
    model,
    onPositionClick,
    revealedAnswers,
    isAnswered
  }) {
    const accidentalPreference = useFretboardConfigStore((state) => state.accidentalPreference);
    const rangeConfig = useFretboardNoteQuizStore((state) => state.rangeConfig);
    const equivalentPositions = useFretboardNoteQuizStore((state) => state.equivalentPositions);
    const circleGradientId = import_react6.default.useId();
    const correctGradientId = import_react6.default.useId();
    const incorrectGradientId = import_react6.default.useId();
    const inactiveGradientId = import_react6.default.useId();
    const equivalentGradientId = import_react6.default.useId();
    const notes = useNoteQuizNotes2({
      layout,
      model,
      rangeConfig,
      revealedAnswers,
      isAnswered,
      equivalentPositions,
      accidentalPreference,
      circleGradientId,
      correctGradientId,
      incorrectGradientId,
      inactiveGradientId,
      equivalentGradientId
    });
    const handleNoteClick = (0, import_react6.useCallback)(
      (note) => {
        if (!isAnswered && note.metadata) {
          onPositionClick(note.metadata);
        }
      },
      [isAnswered, onPositionClick]
    );
    const content = /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(import_jsx_runtime9.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
        NoteQuizGradients,
        {
          circleGradientId,
          correctGradientId,
          incorrectGradientId,
          inactiveGradientId,
          equivalentGradientId
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
        NotesLayer,
        {
          layout,
          model,
          notes,
          onNoteClick: handleNoteClick,
          className: "note-quiz-layer"
        }
      )
    ] });
    return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(G, { children: content });
  };
}

// src/note-quiz/utils/formatters.ts
function formatFretRange(min, max) {
  if (min === 0 && max === 0) {
    return "Open position only";
  } else if (min === 0) {
    return `Open to fret ${max}`;
  } else if (min === max) {
    return `Fret ${min}`;
  } else {
    return `Frets ${min}-${max}`;
  }
}
function formatStringRange(activeStrings, totalStrings) {
  if (activeStrings.length === totalStrings) {
    return "All strings";
  } else if (activeStrings.length === 1) {
    return `String ${activeStrings[0] + 1}`;
  } else {
    const stringNumbers = activeStrings.map((s) => s + 1).sort((a, b) => a - b).join(", ");
    return `Strings ${stringNumbers}`;
  }
}
function formatPracticeRange(fretMin, fretMax, activeStrings, totalStrings) {
  const fretText = formatFretRange(fretMin, fretMax);
  const stringText = formatStringRange(activeStrings, totalStrings);
  return `${fretText} \u2022 ${stringText}`;
}

// src/note-quiz/useFretboardNoteQuizStore.ts
var import_core4 = require("@fretgenius/core");
var import_zustand2 = require("zustand");
var import_middleware2 = require("zustand/middleware");
var createFretboardNoteQuizStore = (options, initialConfig) => {
  const reportErrorFn = options.reportErrorFn;
  return (0, import_zustand2.create)()(
    (0, import_middleware2.persist)(
      (set, get) => {
        var _a, _b, _c, _d;
        const initialFretRange = (_b = (_a = initialConfig == null ? void 0 : initialConfig.rangeConfig) == null ? void 0 : _a.fretRange) != null ? _b : { min: 0, max: 24 };
        const initialActiveStrings = (_d = (_c = initialConfig == null ? void 0 : initialConfig.rangeConfig) == null ? void 0 : _c.activeStrings) != null ? _d : [
          0,
          1,
          2,
          3,
          4,
          5
        ];
        return {
          currentQuestion: null,
          score: 0,
          attempts: 0,
          revealedAnswers: [],
          equivalentPositions: [],
          isAnswered: false,
          quizError: null,
          rangeConfig: {
            fretRange: initialFretRange,
            activeStrings: initialActiveStrings
          },
          startQuiz: (model) => {
            try {
              const question = generateRandomQuestion(model, get().rangeConfig, reportErrorFn);
              set({
                quizError: null,
                currentQuestion: question,
                revealedAnswers: [],
                equivalentPositions: [],
                score: 0,
                attempts: 0,
                isAnswered: false
              });
            } catch (error) {
              reportErrorFn(error, { source: "startQuiz" });
              set({ quizError: "Failed to start the quiz. Please try again." });
            }
          },
          submitAnswer: (answer, model) => {
            const { currentQuestion, score, revealedAnswers, attempts } = get();
            if (!currentQuestion || !currentQuestion.fretPosition || get().isAnswered) return false;
            try {
              set({ quizError: null });
              const isCorrect = import_core4.MusicTheoryService.areNotesEnharmonic(
                currentQuestion.fretPosition.pitch.note,
                answer.pitch.note
              );
              set({
                score: isCorrect ? score + 1 : score,
                attempts: attempts + 1,
                revealedAnswers: [...revealedAnswers, { position: answer, isCorrect }],
                isAnswered: true
              });
              get().findEquivalentPositions(model);
              return isCorrect;
            } catch (error) {
              reportErrorFn(error, { source: "submitAnswer", answer });
              set({ quizError: "Failed to process your answer. Please try again." });
              return false;
            }
          },
          findEquivalentPositions: (model) => {
            const { currentQuestion, rangeConfig } = get();
            if (!currentQuestion || !currentQuestion.fretPosition) return;
            let targetNote;
            try {
              set({ quizError: null });
              targetNote = currentQuestion.fretPosition.pitch.note;
              const equivalentPositions = [];
              rangeConfig.activeStrings.forEach((stringIndex) => {
                for (let fret = rangeConfig.fretRange.min; fret <= rangeConfig.fretRange.max; fret++) {
                  const positionData = model.getPosition(stringIndex, fret);
                  if (!positionData) continue;
                  if (targetNote && import_core4.MusicTheoryService.areNotesEnharmonic(targetNote, positionData.pitch.note)) {
                    equivalentPositions.push({
                      string: stringIndex,
                      fret,
                      pitch: positionData.pitch
                    });
                  }
                }
              });
              set({ equivalentPositions });
            } catch (error) {
              reportErrorFn(error, {
                source: "findEquivalentPositions",
                targetNote: targetNote != null ? targetNote : "unknown"
              });
              set({ quizError: "Failed to find equivalent positions." });
            }
          },
          nextQuestion: (model) => {
            try {
              const question = generateRandomQuestion(model, get().rangeConfig, reportErrorFn);
              set({
                quizError: null,
                currentQuestion: question,
                revealedAnswers: [],
                equivalentPositions: [],
                isAnswered: false
              });
            } catch (error) {
              reportErrorFn(error, { source: "nextQuestion" });
              set({ quizError: "Failed to load the next question. Please try again." });
            }
          },
          setFretRange: (min, max) => {
            set((state) => ({ rangeConfig: __spreadProps(__spreadValues({}, state.rangeConfig), { fretRange: { min, max } }) }));
          },
          setActiveStrings: (stringIndices) => {
            set((state) => ({
              rangeConfig: __spreadProps(__spreadValues({}, state.rangeConfig), { activeStrings: stringIndices })
            }));
          }
        };
      },
      {
        name: "fretboard-note-quiz-preferences",
        storage: options.storage,
        partialize: (state) => ({
          rangeConfig: state.rangeConfig
        })
      }
    )
  );
};
function generateRandomQuestion(model, config, reportErrorFn) {
  try {
    const position = model.getRandomFretPosition(config.fretRange, config.activeStrings);
    if (!position) {
      return {
        error: "No valid positions found with the current range settings. Try adjusting your fret range or active strings."
      };
    }
    return {
      fretPosition: position
    };
  } catch (error) {
    reportErrorFn(error, { source: "generateRandomQuestion", rangeConfig: config });
    return {
      error: "An unexpected error occurred while generating the question."
    };
  }
}

// src/scale-display/createScaleDisplayLayer.tsx
var import_core5 = require("@fretgenius/core");
var import_react7 = require("react");
var import_jsx_runtime10 = require("react/jsx-runtime");
function createScaleDisplayLayer(deps) {
  const {
    NotesLayer,
    useFretboardConfig,
    useCurrentScaleNotes,
    useNoteFormatter,
    useScaleDegreeColor
  } = deps;
  return function ScaleDisplayLayer({ layout }) {
    const { fretboardModel } = useFretboardConfig();
    const scaleNotes = useCurrentScaleNotes();
    const formatNote2 = useNoteFormatter();
    const getScaleDegreeColor = useScaleDegreeColor();
    const notes = (0, import_react7.useMemo)(() => {
      if (scaleNotes.length === 0) {
        return [];
      }
      const fretboardNotes = [];
      const allPositions = fretboardModel.getAllPositions();
      for (const position of allPositions) {
        for (const scaleNote of scaleNotes) {
          if (import_core5.MusicTheoryService.areNotesEnharmonic(scaleNote, position.pitch.note)) {
            const scaleIndex = scaleNotes.findIndex(
              (note) => import_core5.MusicTheoryService.areNotesEnharmonic(note, scaleNote)
            );
            if (scaleIndex < 0) continue;
            const noteColor = getScaleDegreeColor(scaleNote, scaleIndex);
            const displayText = formatNote2(scaleNote, scaleIndex);
            fretboardNotes.push({
              string: position.string,
              fret: position.fret,
              content: displayText,
              color: noteColor,
              visible: true,
              className: "scale-note",
              metadata: {
                noteName: scaleNote,
                scaleIndex
              }
            });
            break;
          }
        }
      }
      return fretboardNotes;
    }, [fretboardModel, scaleNotes, getScaleDegreeColor, formatNote2]);
    if (notes.length === 0) {
      return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
      NotesLayer,
      {
        layout,
        model: fretboardModel,
        notes,
        className: "scale-display-layer",
        textColor: "white",
        dropShadow: "drop-shadow(0px 2px 3px rgba(0,0,0,0.25))"
      }
    );
  };
}

// src/scale-display/useScaleDisplayStore.ts
var import_core6 = require("@fretgenius/core");
var import_zustand3 = require("zustand");
var import_middleware3 = require("zustand/middleware");
var DEFAULT_COLORS = {
  "1": "#A94442",
  // muted red
  "2": "#B16A3B",
  // muted burnt orange
  "3": "#B99A28",
  // muted mustard yellow
  "4": "#6C8F4D",
  // muted olive/green
  "5": "#4C8F96",
  // muted teal blue
  "6": "#496E91",
  // muted blue
  "7": "#7A5E8B"
  // muted purple
};
function createScaleDisplayStore(options, initialConfig) {
  var _a, _b, _c;
  const initialState = {
    rootNote: (_a = initialConfig == null ? void 0 : initialConfig.rootNote) != null ? _a : "C",
    scaleType: (_b = initialConfig == null ? void 0 : initialConfig.scaleType) != null ? _b : import_core6.ScaleNames.Major.value,
    displayMode: (_c = initialConfig == null ? void 0 : initialConfig.displayMode) != null ? _c : import_core6.ScaleDisplayMode.NOTE_NAMES,
    scaleDegreeColors: __spreadValues(__spreadValues({}, DEFAULT_COLORS), initialConfig == null ? void 0 : initialConfig.scaleDegreeColors)
  };
  return (0, import_zustand3.create)()(
    (0, import_middleware3.persist)(
      (set) => __spreadProps(__spreadValues({}, initialState), {
        // Actions
        setRootNote: (rootNote) => set({ rootNote }),
        setScaleType: (scaleType) => set({ scaleType }),
        setDisplayMode: (displayMode) => set({ displayMode }),
        setScaleDegreeColor: (degree, color) => set((state) => ({
          scaleDegreeColors: __spreadProps(__spreadValues({}, state.scaleDegreeColors), {
            [degree]: color
          })
        })),
        // Reset to defaults
        resetScale: () => set({
          rootNote: initialState.rootNote,
          scaleType: initialState.scaleType,
          displayMode: initialState.displayMode
        }),
        resetScaleDegreeColors: () => set({
          scaleDegreeColors: DEFAULT_COLORS
        })
      }),
      {
        name: "fretboard-scale-display",
        storage: options.storage
      }
    )
  );
}
function createCurrentScaleNotesHook(useStore) {
  return function useCurrentScaleNotes(reportErrorFn) {
    const { rootNote, scaleType } = useStore();
    try {
      return import_core6.MusicTheoryService.getScaleNotes(rootNote, scaleType);
    } catch (error) {
      reportErrorFn(error, {
        source: "useCurrentScaleNotes",
        rootNote,
        scaleType
      });
      return [];
    }
  };
}
function createNoteFormatterHook(useStore) {
  return function useNoteFormatter() {
    const { rootNote, scaleType, displayMode } = useStore();
    return (note, scaleIndex) => (0, import_core6.formatNote)(rootNote, note, scaleIndex, scaleType, displayMode);
  };
}
function createStandardizedScaleDegreeHook(useStore) {
  return function useStandardizedScaleDegree(reportErrorFn) {
    const { rootNote, scaleType } = useStore();
    return (note, index) => {
      try {
        if (index !== void 0) {
          return String(
            import_core6.MusicTheoryService.getStandardScaleDegree(note, index, rootNote, scaleType)
          );
        }
        const scaleNotes = import_core6.MusicTheoryService.getScaleNotes(rootNote, scaleType);
        for (let i = 0; i < scaleNotes.length; i++) {
          if (import_core6.MusicTheoryService.areNotesEnharmonic(note, scaleNotes[i])) {
            return String(import_core6.MusicTheoryService.getStandardScaleDegree(note, i, rootNote, scaleType));
          }
        }
        return "1";
      } catch (error) {
        reportErrorFn(error, {
          source: "useStandardizedScaleDegree",
          note,
          index,
          rootNote,
          scaleType
        });
        return "1";
      }
    };
  };
}
function createScaleDegreeColorHook(useStore, useStandardizedDegree) {
  return function useScaleDegreeColor() {
    const { scaleDegreeColors } = useStore();
    const getStandardizedDegree = useStandardizedDegree();
    return (note, index) => {
      const degree = getStandardizedDegree(note, index);
      const safeKey = degree === "1" || degree === "2" || degree === "3" || degree === "4" || degree === "5" || degree === "6" || degree === "7" ? degree : "1";
      return scaleDegreeColors[safeKey];
    };
  };
}

// src/theme/types.ts
var ThemeMode = /* @__PURE__ */ ((ThemeMode2) => {
  ThemeMode2["Light"] = "light";
  ThemeMode2["Dark"] = "dark";
  return ThemeMode2;
})(ThemeMode || {});

// src/theme/createThemeStore.ts
var import_zustand4 = require("zustand");
var import_middleware4 = require("zustand/middleware");

// src/theme/tokens.ts
var FRETBOARD_COLORS = {
  // Fretboard-specific colors
  fretboardBackground: "#f9f6f1",
  fretboardWood: "#59452d",
  // Wood grain from FretboardGradients.tsx
  fretColor: "#444444",
  // From FretboardFrets.tsx
  nutColor: "#f8f8f8",
  // From FretboardFrets.tsx
  stringColorTreble: "rgba(220, 220, 220, 0.9)",
  // From FretboardStrings.tsx
  stringColorBass: "rgba(220, 200, 170, 0.9)",
  // From FretboardStrings.tsx
  markerColor: "#d0d0d0",
  // Based on pearl inlay gradient from FretboardGradients.tsx
  markerSpecialColor: "#305860",
  // Based on abalone gradient from FretboardGradients.tsx
  // Fret metal gradient colors
  fretMetalLight: "#a0a0a0",
  // Light color for fret metal gradient
  fretMetalMid: "#808080",
  // Middle color for fret metal gradient
  fretMetalDark: "#606060",
  // Dark color for fret metal gradient
  // Pearl inlay gradient colors
  pearlInlay: ["#ffffff", "#f5f5f5", "#e0e0e0", "#d8d8d8", "#d0d0d0"],
  // Abalone gradient colors
  abalone: ["#c0e8f5", "#a0d8e0", "#80c0c8", "#60a8b0", "#407878", "#305860"]
};
var lightThemeTokens = __spreadValues({
  // Base colors
  background: "#f9f6f1",
  // base-100 (cupcake)
  surfacePrimary: "#f3eeea",
  // base-200 (cupcake)
  surfaceSecondary: "#ebe4dd",
  // base-300 (cupcake)
  // Text colors
  textPrimary: "#433A3F",
  // base-content (cupcake)
  textSecondary: "#6e6167",
  // lighter version of base-content
  // Brand colors
  primary: "#b4e9d6",
  // primary (cupcake)
  primaryContent: "#60a5a7",
  // primary-content (cupcake)
  secondary: "#fbd3e1",
  // secondary (cupcake)
  secondaryContent: "#d76f83",
  // secondary-content (cupcake)
  accent: "#f2d0a4",
  // accent (cupcake)
  accentContent: "#c18659",
  // accent-content (cupcake)
  neutral: "#3b3437",
  // neutral (cupcake)
  neutralContent: "#eceaeb",
  // neutral-content (cupcake)
  // Status colors
  info: "#8ad6f2",
  // info (cupcake)
  infoContent: "#3b6d87",
  // info-content (cupcake)
  success: "#a5e0c5",
  // success (cupcake)
  successContent: "#2d6244",
  // success-content (cupcake)
  warning: "#fcd777",
  // warning (cupcake)
  warningContent: "#7f5f14",
  // warning-content (cupcake)
  error: "#ee9e9c",
  // error (cupcake)
  errorContent: "#782928",
  // error-content (cupcake)
  // Border colors
  border: "#e3d9cd"
}, FRETBOARD_COLORS);
var darkThemeTokens = __spreadValues({
  // Base colors
  background: "#2a303c",
  // base-100 (dark)
  surfacePrimary: "#242933",
  // base-200 (dark)
  surfaceSecondary: "#1f242d",
  // base-300 (dark)
  // Text colors
  textPrimary: "#f8f9fc",
  // base-content (dark)
  textSecondary: "#a6adbb",
  // lighter version of base-content
  // Brand colors
  primary: "#9747ff",
  // primary (dark)
  primaryContent: "#f2f2fa",
  // primary-content (dark)
  secondary: "#f872a3",
  // secondary (dark)
  secondaryContent: "#f5f5f8",
  // secondary-content (dark)
  accent: "#acecfa",
  // accent (dark)
  accentContent: "#4c555e",
  // accent-content (dark)
  neutral: "#1e2023",
  // neutral (dark)
  neutralContent: "#eceaeb",
  // neutral-content (dark)
  // Status colors
  info: "#a4cafe",
  // info (dark)
  infoContent: "#3b6d87",
  // info-content (dark)
  success: "#b9f5d0",
  // success (dark)
  successContent: "#4b725c",
  // success-content (dark)
  warning: "#fee08a",
  // warning (dark)
  warningContent: "#745823",
  // warning-content (dark)
  error: "#f9a8a8",
  // error (dark)
  errorContent: "#782928",
  // error-content (dark)
  // Border colors
  border: "#3d4352"
}, FRETBOARD_COLORS);

// src/theme/createThemeStore.ts
var createThemeStore = (options) => {
  const { storage, reportErrorFn } = options;
  return (0, import_zustand4.create)()(
    (0, import_middleware4.persist)(
      (set) => {
        const initialMode = options.getInitialMode ? options.getInitialMode() : "light" /* Light */;
        return {
          mode: initialMode,
          colors: initialMode === "light" /* Light */ ? lightThemeTokens : darkThemeTokens,
          setThemeMode: (mode) => {
            const newColors = mode === "light" /* Light */ ? lightThemeTokens : darkThemeTokens;
            set({ mode, colors: newColors });
          }
        };
      },
      {
        name: "theme-preferences",
        storage,
        partialize: (state) => ({
          mode: state.mode
        }),
        onRehydrateStorage: () => {
          return (persistedState, error) => {
            if (error) {
              reportErrorFn(error, { source: "createThemeStore.onRehydrateStorage" });
              return;
            }
            if (persistedState) {
              persistedState.colors = persistedState.mode === "light" /* Light */ ? lightThemeTokens : darkThemeTokens;
            }
          };
        }
      }
    )
  );
};

// src/feedback/stores/createFeedbackStore.ts
var import_database = require("@fretgenius/database");
var import_zustand5 = require("zustand");
function createFeedbackStore(options) {
  const { supabaseClient, reportErrorFn } = options;
  return (0, import_zustand5.create)()((set, get) => ({
    type: "feature_request",
    description: "",
    email: "",
    isSubmitting: false,
    isSuccess: false,
    errorMessage: null,
    setType: (type) => set({ type }),
    setDescription: (description) => set({ description }),
    setEmail: (email) => set({ email }),
    resetForm: () => set({
      type: "feature_request",
      description: "",
      email: "",
      isSubmitting: false,
      isSuccess: false,
      errorMessage: null
    }),
    submitFeedback: () => __async(this, null, function* () {
      const { type, description, email } = get();
      if (!description.trim()) {
        set({ errorMessage: "Please enter a description" });
        return;
      }
      set({ isSubmitting: true, isSuccess: false, errorMessage: null });
      try {
        const { error } = yield supabaseClient.from(import_database.TABLES.FEEDBACK).insert([
          {
            type,
            description,
            email: email.trim() || null,
            created_at: (/* @__PURE__ */ new Date()).toISOString()
          }
        ]);
        if (error) throw error;
        set({ isSubmitting: false, isSuccess: true });
      } catch (error) {
        reportErrorFn(error, {
          source: "createFeedbackStore.submitFeedback",
          feedbackType: type
        });
        set({
          isSubmitting: false,
          errorMessage: error instanceof Error ? error.message : "Failed to submit feedback. Please try again."
        });
      }
    })
  }));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AccidentalPreference,
  DEFAULT_COLORS,
  FRETBOARD_MARGIN_FACTOR,
  ThemeMode,
  createBaseGridLayer,
  createCurrentScaleNotesHook,
  createFeedbackStore,
  createFretboardConfigStore,
  createFretboardDimensionsHook,
  createFretboardFrets,
  createFretboardGradients,
  createFretboardGrid,
  createFretboardLayoutHook,
  createFretboardMarkers,
  createFretboardNoteQuizStore,
  createFretboardStrings,
  createNoteFormatterHook,
  createNoteGuessLayer,
  createNoteQuizGradients,
  createNotesLayer,
  createNotesLayerComponent,
  createScaleDegreeColorHook,
  createScaleDisplayLayer,
  createScaleDisplayStore,
  createStandardizedScaleDegreeHook,
  createThemeStore,
  darkThemeTokens,
  formatFretRange,
  formatNoteDisplay,
  formatPracticeRange,
  formatStringRange,
  getFretboardEdgeY,
  getMarkerPosition,
  lightThemeTokens,
  useNoteQuizNotes
});
//# sourceMappingURL=index.js.map